import React from 'react';
import VoucherPage from './VoucherPage';

const WebhostingNoLimitPage: React.FC = () => {
  return <VoucherPage category="webhostingNoLimit" />;
};

export default WebhostingNoLimitPage;
